import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { formApi } from '../../services';
import { getSlotFields, SlotField } from './calendar/bookingEvents';
import { ResponsesView } from './ResponsesViewToggle';

export const RESPONSES_PAGE_SIZE = 10;

export interface FormResponse {
  id: string;
  _id?: string;
  createdAt: string;
  data: any;
}

export const useFormResponses = (tenantId?: string, formId?: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Math.max(1, parseInt(searchParams.get('page') || '1', 10) || 1);
  const view: ResponsesView = searchParams.get('view') === 'calendar' ? 'calendar' : 'list';
  const [responses, setResponses] = useState<FormResponse[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [formName, setFormName] = useState('');
  const [slotFields, setSlotFields] = useState<SlotField[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResponses = async () => {
      try {
        setLoading(true);
        const [responsesData, formData] = await Promise.all([
          formApi.getFormResponses(tenantId!, formId!, page, RESPONSES_PAGE_SIZE),
          formApi.getForm(tenantId!, formId!),
        ]);
        if (Array.isArray(responsesData)) {
          setResponses(responsesData);
          setTotalCount(responsesData.length);
        } else {
          setResponses(responsesData?.rows || []);
          setTotalCount(responsesData?.count || 0);
        }
        setFormName(formData.name || '');
        setSlotFields(getSlotFields(formData.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    if (tenantId && formId) {
      fetchResponses();
    }
  }, [tenantId, formId, page]);

  const handlePageChange = (value: number) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('page', String(value));
      return next;
    });
  };

  const handleViewChange = (next: ResponsesView) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (next === 'calendar') params.set('view', next);
      else params.delete('view');
      return params;
    });
  };

  return {
    responses,
    totalCount,
    formName,
    slotFields,
    loading,
    page,
    view,
    handlePageChange,
    handleViewChange,
  };
};
